import React, { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import axios from 'axios';
import { API_BASE_URL, STRIPE_PUBLISHABLE_KEY } from '../config';

// Lazy-load because public key is environment-specific
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default function Checkout() {
  useEffect(() => {
    const createSession = async () => {
      try {
        // Hit our backend to create a Checkout Session
        const token = localStorage.getItem('token');
        const res = await axios.post(`${API_BASE_URL}/api/v1/payments/create-checkout-session`, {}, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          }
        });
        window.location.href = res.data.url; // Redirect to Stripe Checkout
      } catch (err) {
        console.error('Unable to start payment flow', err);
        // TODO: show UI error & fallback
      }
    };
    createSession();
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    </Elements>
  );
}
